import {stage} from './stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        enabled: boolean;
        policyStoreId: string;
        region: string;
        namespace: string
    };
};

export const config: ConfigShape = {
    prod: {
        enabled: true,
        policyStoreId: '5rKYGz2SVVZeGKJnDPaiag',
        region: 'us-west-2',
        namespace: 'FlexiEmail'
    },
    test: {
        enabled: true,
        policyStoreId: 'TbmYTTTPesY2X2KgdT5bza',
        region: 'us-west-2',
        namespace: 'FlexiEmail',
    },
    dev: {
        enabled: true,
        policyStoreId: '11xEERursJEmCzobzeG4d',
        region: 'us-west-2',
        namespace: 'FlexiEmail',
    },
    ide: {
        enabled: true,
        policyStoreId: '11xEERursJEmCzobzeG4d',
        region: 'us-west-2',
        namespace: 'FlexiEmail',
    },
};

export default config[stage];
